import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Fade from 'react-reveal/Fade'

import AgentTile from './AgentTile'
import ContentHolder from '../../ui/ContentHolder'
import styles from './styles.scss'

class Footer extends Component {
  _renderAgents = () => {
    const { agents, campaign } = this.props
    if (!campaign.agents) return null

    return campaign.agents.map((agentId) => {
      const agent = agents[agentId] || {}
      return (
        <AgentTile key={agent.id} agent={agent} />
      )
    })
  }

  render(){
    const {
      brand: { logo },
    } = this.props

    return (
      <div className={styles.root}>
        <ContentHolder>
          <div className={styles.content}>
            <span className={styles.logo} style={{ backgroundImage: logo ? `url(${logo.small})` : null }} />

            <Fade>
              <span className={styles.text}>Thank you for your time</span>
            </Fade>

            <div className={styles.agents}>{this._renderAgents()}</div>

          </div>
        </ContentHolder>
      </div>
    )
  }
}

Footer.propTypes = {
  agents: PropTypes.object.isRequired,
  brand: PropTypes.object.isRequired,
  campaign: PropTypes.object.isRequired,
}

export default Footer
